module.exports = __webpack_public_path__ + "static/media/rga_girls.37976596.jpg";